import { Component, OnInit, input } from '@angular/core';
import { ModalModel } from '@shared-model/modal/ModalModel';
import { ModalTypeClass } from '@shared-model/modal/ModalTypeClass';

@Component({
    selector: 'fourd-modal',
    templateUrl: './modal.component.html',
    host: {
        '[class]': 'modalTypeClass'
    }
})
export class ModalComponent implements OnInit {
  readonly modal = input<ModalModel>(undefined);

  modalTypeClass: string;

  constructor() { }

  ngOnInit() {
    const modal = this.modal();
    if (modal && modal.Type) {
      this.modalTypeClass = ModalTypeClass[modal.Type];
    }
  }

}
